module.exports = __webpack_public_path__ + "static/media/flute.32a1c441.svg";